import { getPMDetails } from '~/integrations/PracticeManagement/pm.utils';
import { NotificationStatus, NotificationSettingsModel } from '~/models/NotificationSettingsModel';
import { PracticeManagement } from '~/types/api.model';
export const notificationSettingsTextsPath = 'pages.notificationSettings';
export var Tab = /*#__PURE__*/ function(Tab) {
    Tab["Vendor"] = "vendor";
    Tab["Client"] = "customer";
    return Tab;
}({});
export var Table = /*#__PURE__*/ function(Table) {
    Table["Notifications"] = "notifications";
    Table["Reminders"] = "reminders";
    return Table;
}({});
export const notificationColumnDefs = [
    {
        width: 400
    },
    {
        width: 210
    },
    {
        width: 200
    }
];
export const getNotificationHeaderItems = (texts)=>[
        {
            value: texts.tableHeaders.eventName()
        },
        {
            value: texts.tableHeaders.status()
        },
        {
            value: texts.tableHeaders.recipients()
        }
    ];
const clientReminderColumnDefs = [
    {
        width: 400
    },
    {
        width: 60
    },
    {
        width: 80
    },
    {
        width: 40
    },
    {
        width: 140
    }
];
const getClientReminderHeaderItems = (texts)=>[
        {
            value: texts.tableHeaders.delayedAction()
        },
        {
            value: texts.tableHeaders.status()
        },
        {
            value: texts.tableHeaders.interval()
        },
        {
            value: texts.tableHeaders.retries()
        },
        {
            value: texts.tableHeaders.recipients()
        }
    ];
const vendorReminderColumnDefs = [
    {
        width: 400
    },
    {
        width: 100
    },
    {
        width: 100
    },
    {
        width: 200
    }
];
const getVendorReminderHeaderItems = (texts)=>[
        {
            value: texts.tableHeaders.delayedAction()
        },
        {
            value: texts.tableHeaders.status()
        },
        {
            value: texts.tableHeaders.delay()
        },
        {
            value: texts.tableHeaders.recipients()
        }
    ];
export const reminderColumnDefsMap = {
    ["vendor"]: vendorReminderColumnDefs,
    ["customer"]: clientReminderColumnDefs
};
export const getReminderHeaderItems = (tab, texts)=>tab === "vendor" ? getVendorReminderHeaderItems(texts) : getClientReminderHeaderItems(texts);
function getVendorNotificationToShowTextMap(param) {
    let { showKarbonIntegration, showClientHubIntegration, showFinancialCentsIntegration, showKeeperIntegration, featureFlags, texts } = param;
    const eventNames = texts.eventNames;
    const map = {
        relationshipApprovedVendor: eventNames.proposalSigned(),
        relationshipAmendmentsApprovedVendor: eventNames.amendmentApproved(),
        paymentFailedVendor: eventNames.paymentFailed(),
        invoiceRefundedVendor: eventNames.paymentRefunded(),
        invoiceRefundFailedVendor: eventNames.refundFailed(),
        payoutDepositedVendor: eventNames.payoutDeposited(),
        proposalNotSignedReminderVendor: eventNames.proposalNotSigned(),
        amendmentsNotApprovedReminderVendor: eventNames.amendmentNotApprovedVendor(),
        bankAccountNotVerifiedReminderVendor: eventNames.bankAccountNotVerifiedVendor(),
        payoutFailedVendor: eventNames.payoutFailed()
    };
    if (showFinancialCentsIntegration) map.relationshipFinancialCentsFailedItems = eventNames.pmProjectCreationFailed({
        pmName: getPMDetails(PracticeManagement.FinancialCents).name
    });
    if (showKarbonIntegration) map.relationshipKarbonFailedItems = eventNames.pmWorkItemCreationFailed({
        pmName: getPMDetails(PracticeManagement.Karbon).name
    });
    if (showClientHubIntegration) map.relationshipClientHubFailedItems = eventNames.pmProjectCreationFailed({
        pmName: getPMDetails(PracticeManagement.ClientHub).name
    });
    if (showKeeperIntegration) map.relationshipKeeperFailedItems = eventNames.pmTaskCreationFailed({
        pmName: getPMDetails(PracticeManagement.Keeper).name
    });
    if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.ACH_MANDATE_REAUTHORIZATION) {
        map.bankAccountAuthorizationRequiredVendor = eventNames.bankAccountAuthorizationRequiredVendor();
        map.bankAccountBlockedVendor = eventNames.bankAccountBlockedVendor();
    }
    return map;
}
const getClientNotificationToShowTextMap = (param)=>{
    let { featureFlags, texts } = param;
    const eventNames = texts.eventNames;
    const map = {};
    map.invoiceIssuedAutoProcess = eventNames.invoiceIssued();
    map.adHocInvoiceIssued = eventNames.invoiceIssuedWithoutAgreement();
    map.adHocInvoicePaidConfirmation = eventNames.invoicePaidWithoutAgreement();
    map.relationshipApprovedCustomer = eventNames.proposalSigned();
    map.invoiceIssuedRequiresApproval = eventNames.invoiceRequiresApproval();
    map.paymentFailedCustomer = eventNames.paymentFailed();
    map.relationshipUpdatedWithChanges = eventNames.agreementAmended();
    map.relationshipTerminated = eventNames.agreementTerminated();
    map.invoiceRefundedCustomer = eventNames.paymentRefunded();
    map.proposalNotSignedReminderCustomer = eventNames.proposalNotSigned();
    map.amendmentApprovalReminderCustomer = eventNames.amendmentNotApproved();
    map.bankAccountNotVerifiedReminderCustomer = eventNames.bankAccountNotVerified();
    map.adHocInvoiceOverdueReminderCustomer = eventNames.invoiceIssuedWithoutAgreementIsOverdue();
    if (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.ACH_MANDATE_REAUTHORIZATION) {
        map.bankAccountAuthorizationRequiredCustomer = eventNames.bankAccountAuthorizationRequired();
        map.bankAccountBlockedCustomer = eventNames.bankAccountBlocked();
    }
    return map;
};
export function getNotificationsToShow(opts) {
    if (opts.tab === "vendor") return getVendorNotificationToShowTextMap(opts);
    return getClientNotificationToShowTextMap(opts);
}
const vendorProposalNotifications = [
    'proposalNotSignedReminderVendor',
    'relationshipApprovedVendor'
];
const adHocNotifications = [
    'adHocInvoiceIssued',
    'adHocInvoicePaidConfirmation',
    'adHocInvoiceOverdueReminderCustomer'
];
export const getRecipientTypeTextMap = (param)=>{
    let { notificationName, texts, featureFlags } = param;
    const primaryContactText = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.FE_CRM) ? texts.recipientTypes.mainSignatory() : texts.recipientTypes.primaryContact();
    const primaryContactAndSignatoriesText = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.FE_CRM) ? texts.recipientTypes.mainSignatoryAndAdditionalSignatories() : texts.recipientTypes.primaryContactAndSignatories();
    return {
        all: notificationName === 'proposalNotSignedReminderCustomer' ? primaryContactAndSignatoriesText : adHocNotifications.includes(notificationName) ? primaryContactText : texts.recipientTypes.allTeamMembers(),
        owner: texts.recipientTypes.owner(),
        admin: texts.recipientTypes.admin(),
        assignee: vendorProposalNotifications.includes(notificationName) ? texts.recipientTypes.sender() : texts.recipientTypes.assignedTeamMember()
    };
};
export const getEditDropdownRecipientTypeText = (param)=>{
    let { notificationName, texts } = param;
    return {
        all: texts.editDropdownRecipientTypes.allTeamMembers(),
        owner: texts.editDropdownRecipientTypes.ownerRole(),
        admin: texts.editDropdownRecipientTypes.adminRole(),
        assignee: vendorProposalNotifications.includes(notificationName) ? texts.editDropdownRecipientTypes.sender() : texts.editDropdownRecipientTypes.assignedTeamMember()
    };
};
export const getRecipientTypesText = (param)=>{
    let { recipientTypes, notificationName, texts, featureFlags } = param;
    return recipientTypes.includes('all') ? [
        getRecipientTypeTextMap({
            notificationName,
            texts,
            featureFlags
        }).all
    ] : recipientTypes.map((recipientType)=>getRecipientTypeTextMap({
            notificationName,
            texts,
            featureFlags
        })[recipientType]);
};
export const getJoinedRecipientTypesText = (param)=>{
    let { recipientTypes, notificationName, texts, featureFlags } = param;
    return getRecipientTypesText({
        recipientTypes,
        notificationName,
        texts,
        featureFlags
    }).join(', ');
};
export const minutesToDays = (minutes)=>Math.floor(minutes / 60 / 24);
export const daysToMinutes = (days)=>days * 60 * 24;
export const isDays = (minutes)=>minutes % (60 * 24) === 0;
export const formatClientReminderInterval = (minutes, times, texts)=>isDays(minutes) ? texts.clientReminderIntervalDays({
        days: minutesToDays(minutes),
        times
    }) : texts.clientReminderIntervalMinutes({
        minutes,
        times
    });
export const deriveIsActive = (notification)=>notification.status === NotificationStatus.Active;
export const deriveToggleState = (notification)=>{
    const isNonEditable = !notification.editability.recipients;
    const checked = deriveIsActive(notification);
    return {
        checked,
        disabled: isNonEditable,
        showAlwaysOnTooltip: isNonEditable && checked
    };
};
// The legacy table renders the operational state ("will this notification fire?"), so a vendor
// who toggled to Silent via the V2 UI should see Inactive even when the FF is later turned off
// and recipients remain populated.
export const deriveLegacyIsActive = (notification)=>notification.recipientTypes.length > 0 && notification.status !== NotificationStatus.Silent;
export const handleSetRecipientTypes = (param)=>{
    let { newType, newRecipientTypes, setRecipientTypes } = param;
    setRecipientTypes(newRecipientTypes.includes('all') ? newType === 'all' ? [
        'all'
    ] : newRecipientTypes.filter((x)=>x !== 'all') : newRecipientTypes);
};
export const getFallbackRecipientTypes = (param)=>{
    let { recipientTypes, defaultRecipientType, originalRecipientTypes } = param;
    return NotificationSettingsModel.hasRecipients({
        recipientTypes
    }) ? [] : NotificationSettingsModel.hasRecipients({
        recipientTypes: originalRecipientTypes
    }) ? originalRecipientTypes : [
        defaultRecipientType
    ];
};
export const getEmailProviderDetails = (provider)=>({
        biCodes: ({
            gmail: {
                connect: 18501,
                completeAuth: 18502,
                authError: 18503,
                disconnect: 18504
            },
            outlook: {
                connect: 18511,
                completeAuth: 18512,
                authError: 18513,
                disconnect: 18514
            }
        })[provider]
    });
